var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "message-body" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            },
            keydown: function($event) {
              return _vm.form.errors.clear($event.target.name)
            }
          }
        },
        [
          _c("p", { staticClass: "control" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.body,
                  expression: "form.body"
                }
              ],
              staticClass: "textarea",
              attrs: { placeholder: "Escriba su nuevo mensaje", name: "body" },
              domProps: { value: _vm.form.body },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "body", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "control" }, [
            _vm.form.errors.has("body")
              ? _c("span", {
                  staticClass: "help is-danger",
                  domProps: { textContent: _vm._s(_vm.form.errors.get("body")) }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                attrs: { disabled: _vm.form.errors.any() }
              },
              [_vm._v("\n                    Enviar\n                ")]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message-header" }, [
      _c("p", [_vm._v("Agregar nuevo anuncio general...")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }